import { Component, OnInit } from '@angular/core';
import { WiseIdAuthServiceManager } from '../../controller/wise-id-auth.service-manager';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class LogoutComponent implements OnInit {

  constructor(private wiseIdAuthServiceManager: WiseIdAuthServiceManager) { }

  async ngOnInit(): Promise<void> {
    this.wiseIdAuthServiceManager.logout();
    await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate a delay
    window.location.href = '/home'; // Redirect to home page after logout
  }
}
